import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { Card } from "../components/ui";
import { meQueryOptions } from "../features/auth/session";
import { TwoFactorChallenge } from "../features/auth/TwoFactorChallenge";
import { useT } from "../i18n/I18nProvider";
import { safeRedirect } from "../features/auth/redirect";

export const Route = createFileRoute("/two-factor")({
  validateSearch: z.object({
    redirect: z.string().optional(),
    method: z.enum(["totp", "otp"]).optional(),
  }),
  component: TwoFactorPage,
});

function TwoFactorPage() {
  const t = useT();
  const navigate = useNavigate();
  const { redirect, method } = Route.useSearch();
  const { queryClient } = Route.useRouteContext();
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.twoFactor.title")}>
        <TwoFactorChallenge
          method={method ?? "totp"}
          onVerified={async () => {
            queryClient.removeQueries({ queryKey: meQueryOptions().queryKey });
            await navigate({ href: safeRedirect(redirect) });
          }}
        />
      </Card>
    </main>
  );
}
